<mat-expansion-panel class="mat-elevation-z0">
  <mat-expansion-panel-header>
    <mat-panel-title class="text-xs text-700 uppercase font-medium">
      {{title}}
      <span *ngIf="showFiltersAppliedCount()" class="text-xs font-light px-2">
      ({{filtersAppliedCount()}})
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="flex flex-column gap-2">
    <ng-content></ng-content>
  </div>
</mat-expansion-panel>
